// src/components/Faq.jsx
import React, { useState } from "react";
import "./Faq.css";

// Tutaj możesz łatwo dodawać, usuwać i edytować pytania i odpowiedzi
const faqData = [
  {
    question: "Jak wyglądają lekcje online?",
    answer:
      "Lekcje prowadzę za pomocą tableta graficznego komunikując się przez Discorda. Kluczowym narzędziem jest interaktywna tablica online, na której wspólnie rozwiązujemy zadania w czasie rzeczywistym.",
  },
  {
    question: "Co w przypadku konieczności odwołania lekcji?",
    answer:
      "Rozumiem, że zdarzają się sytuacje losowe. Proszę o informację o konieczności odwołania zajęć najpóźniej dzień przed planowanym terminem jeśli jest taka możliwość.",
  },
  {
    question: "Czy otrzymam materiały dodatkowe?",
    answer:
      "Oczywiście! Po każdych zajęciach masz wciąż dostęp do archiwalnej wersji tablicy oraz, w razie potrzeby przesyłam dodatkowe zadania do samodzielnego przećwiczenia. Wszystkie materiały są w cenie lekcji.",
  },
  {
    question: "Jak i kiedy należy dokonać płatności?",
    answer:
      "Płatności należy dokonać przed rozpoczęciem zajęć za pomocą przelewu bankowego. Dane do przelewu podaję w wiadomości prywatnej.",
  },
];

const FaqItem = ({ faq, index, openIndex, onToggle }) => {
  const isOpen = index === openIndex;

  return (
    <div className="faq-item">
      <div className="faq-question" onClick={() => onToggle(index)}>
        <span>{faq.question}</span>
        <span className="faq-icon">{isOpen ? "−" : "+"}</span>
      </div>
      <div className={`faq-answer ${isOpen ? "open" : ""}`}>
        <p>{faq.answer}</p>
      </div>
    </div>
  );
};

function Faq() {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="section section-bg">
      <div className="container">
        <div className="section-title">
          <h2>Częste Pytania</h2>
        </div>
        <div className="faq-list">
          {faqData.map((faq, index) => (
            <FaqItem
              key={index}
              faq={faq}
              index={index}
              openIndex={openIndex}
              onToggle={handleToggle}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Faq;